import apiClient from "../../../api/apiClient";

// ============================================================
// GET DUE CALIBRATION CERTIFICATES
// ============================================================

export const getDueCalibrationCertificatesReportApi =
  async (
    customerId: string,
    startDate: string,
    endDate: string,
    tenantId: string
  ) => {
    const res = await apiClient.post(
      "/calibration-certificates/due",
      {
        customerId: customerId || null,
        startDate: startDate || null,
        endDate: endDate || null,
      },
      {
        params: {
          tenantId,
        },
      }
    );

    return res.data;
  };


// ============================================================
// GET DUE WEIGHT TESTS
// ============================================================

export const getDueWeightTestsReportApi =
  async (
    customerName: string,
    startDate: string,
    endDate: string,
    tenantId: string
  ) => {
    const res = await apiClient.post(
      "/weight-tests/due",
      {
        customerName: customerName || null,
        startDate: startDate || null,
        endDate: endDate || null,
      },
      {
        params: {
          tenantId,
        },
      }
    );

    return res.data;
  };


